import React from 'react';
import { Helmet } from 'react-helmet';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import { useLanguage } from '@/hooks/useLanguage';

const PrivacyPolicy = () => {
  const { language } = useLanguage();

  return (
    <>
      <Helmet>
        <title>{language === 'de' ? 'Datenschutzerklärung' : 'Privacy Policy'} | Matthias Meyfarth – Videograf, Fotograf & Webdesigner aus Berlin</title>
        <meta name="description" content={language === 'de' 
          ? "Datenschutzerklärung von Matthias Meyfarth, Berlin – wie wir Ihre Daten schützen und verwenden."
          : "Privacy Policy of Matthias Meyfarth, Berlin – how we protect and use your data."} />
        <meta property="og:title" content={language === 'de' 
          ? "Datenschutzerklärung | Matthias Meyfarth – Videograf, Fotograf & Webdesigner aus Berlin"
          : "Privacy Policy | Matthias Meyfarth – Videograf, Fotograf & Webdesigner from Berlin"} />
        <meta property="og:description" content={language === 'de' 
          ? "Informationen zum Datenschutz auf der Website von Matthias Meyfarth."
          : "Privacy information for the website of Matthias Meyfarth."} />
        <meta property="og:type" content="website" />
      </Helmet>

      <Navigation />

      <main className="container mx-auto px-6 py-24">
        <h1 className="text-4xl font-bold mb-8">
          {language === 'de' ? 'Datenschutzerklärung' : 'Privacy Policy'}
        </h1>

        <p className="mb-4">
          {language === 'de'
            ? 'Wir freuen uns über Ihr Interesse an unserer Website. Der Schutz Ihrer Privatsphäre ist für uns sehr wichtig. Nachstehend informieren wir Sie ausführlich über den Umgang mit Ihren Daten.'
            : 'We are pleased about your interest in our website. The protection of your privacy is very important to us. Below we inform you in detail about the handling of your data.'}
        </p>

        <h2 className="text-2xl font-bold mb-4 mt-8">
          {language === 'de' ? 'Verantwortliche Stelle' : 'Responsible Entity'}
        </h2>

        <p className="mb-4">
          Matthias Meyfarth<br />
          Berlin, Deutschland<br />
          E-Mail: meyf@meyf-art.de
        </p>

        <h2 className="text-2xl font-bold mb-4 mt-8">
          {language === 'de' ? 'Erhebung und Verarbeitung persönlicher Daten' : 'Collection and Processing of Personal Data'}
        </h2>

        <p className="mb-4">
          {language === 'de'
            ? 'Sie können unsere Seiten besuchen, ohne Angaben zu Ihrer Person zu machen. Personenbezogene Daten werden nur erhoben, wenn Sie uns diese im Rahmen Ihrer Kontaktaufnahme freiwillig mitteilen.'
            : 'You can visit our pages without providing any personal information. Personal data is only collected if you voluntarily provide it to us when contacting us.'}
        </p>

        <h2 className="text-2xl font-bold mb-4 mt-8">
          {language === 'de' ? 'Verwendung von Cookies' : 'Use of Cookies'}
        </h2>

        <p className="mb-4">
          {language === 'de'
            ? 'Diese Website verwendet keine Cookies zur Erhebung personenbezogener Daten.'
            : 'This website does not use cookies to collect personal data.'}
        </p>

        <h2 className="text-2xl font-bold mb-4 mt-8">
          {language === 'de' ? 'Ihre Rechte' : 'Your Rights'}
        </h2>

        <p className="mb-4">
          {language === 'de'
            ? 'Sie haben das Recht, unentgeltlich Auskunft über Ihre gespeicherten Daten zu erhalten sowie das Recht auf Berichtigung, Sperrung oder Löschung dieser Daten.'
            : 'You have the right to receive free information about your stored data as well as the right to correct, block or delete this data.'}
        </p>

        <p className="mt-8">
          {language === 'de'
            ? 'Bei Fragen zur Erhebung, Verarbeitung oder Nutzung Ihrer personenbezogenen Daten sowie bei Auskünften, Berichtigung, Sperrung oder Löschung von Daten wenden Sie sich bitte an:'
            : 'If you have any questions about the collection, processing or use of your personal data as well as for information, correction, blocking or deletion of data, please contact:'}
        </p>

        <p className="mb-4">
          Matthias Meyfarth<br />
          Berlin, Deutschland<br />
          E-Mail: meyf@meyf-art.de
        </p>
      </main>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;